module.exports = __webpack_public_path__ + "static/media/DisableCheckbox.7ca2a4b5.svg";